import React from 'react';

export default function Unauthorized({ attemptId }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900">
      <div className="bg-gray-800 shadow-xl rounded-2xl p-10 max-w-md w-full text-center">
        <h1 className="text-5xl font-bold text-red-500 mb-4">401</h1>
        <h2 className="text-2xl font-semibold text-white mb-2">Unauthorized Access</h2>
        <p className="text-gray-400 mb-8">
          Missing or invalid <code className="text-gray-300">operator</code> or <code className="text-gray-300">attemptId</code> parameter.
        </p>
        <button
          onClick={() => window.location.href = `funteron://auth-return?attemptId=${attemptId}&status=error&errorCode=Unauthorized Access`}
          className="bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-8 rounded-lg transition duration-200 text-lg"
        >
          Try Again
        </button>
      </div>
    </div>
  );
}
